'use client';
import { createGlobalStyle, css } from 'styled-components';
import { media } from './mixins/responsive';
export const createFontSizeCSS = (size, isHeading, fontWeight) => css `
  margin: 0;
  font-size: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _a === void 0 ? void 0 : _a[size]; }};
  line-height: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.fontsLineHeights) === null || _a === void 0 ? void 0 : _a[size]; }};
  letter-spacing: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.letterSpacing) === null || _a === void 0 ? void 0 : _a[size]; }}px;
  font-family: ${isHeading ? 'Figtree' : 'Inter'};
  font-weight: ${({ theme }) => isHeading || fontWeight === 'bold'
    ? theme.fontWeights.semibold
    : fontWeight === 'medium'
        ? theme.fontWeights.medium
        : theme.fontWeights.regular};

  @media (max-width: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _a === void 0 ? void 0 : _a.tablet; }}px) {
    font-size: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.fonts) === null || _a === void 0 ? void 0 : _a[`${size}_md`]; }};
    line-height: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.fontsLineHeights) === null || _a === void 0 ? void 0 : _a[`${size}_md`]; }};
    letter-spacing: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.letterSpacing) === null || _a === void 0 ? void 0 : _a[`${size}_md`]; }}px;
  }
`;
export const GlobalTypographyStyling = createGlobalStyle `
.h1{
  ${createFontSizeCSS('h1', true)}
}
.h2{
  ${createFontSizeCSS('h2', true)}
}
.h3{
  ${createFontSizeCSS('h3', true)}
}
.h4{
  ${createFontSizeCSS('h4', true)}
}
.h5{
  ${createFontSizeCSS('h5', true)}
}
.h6 {
  ${createFontSizeCSS('h6', true)}
}

.subtitle1 {
  ${createFontSizeCSS('subtitle1', false, 'medium')}
}

.subtitle2 {
  ${createFontSizeCSS('subtitle2', false, 'medium')}
}

.body1 {
  ${createFontSizeCSS('body1')}
}
.body2 {
  ${createFontSizeCSS('body2')}
}
.body3 {
  ${createFontSizeCSS('body3')}
}

.caption {
  ${createFontSizeCSS('caption')}
}

.overline {
  text-transform: uppercase;
  ${createFontSizeCSS('overline', false, 'medium')}
}

p {
  margin-block: ${({ theme }) => theme.appearance.spacing * 1}px; // 12px
}

 ul,
  ol {
    list-style-position: outside;
    margin-block: 12px;
    margin-inline-start: 24px;
    li {
      margin-block: 6px;
      padding-inline-start: 8px;
      & > * {
        display: inline;
      }
    }
  }
    ul.ant-pagination {
    margin-block:0;
    margin-inline-start:0;

    li {
      padding-inline-start:0;
      margin-block:0;
    }
    .ant-pagination-item {
      
      border:1px solid ${({ theme }) => theme.colors.grey_4};
      }
  }
  ${[...Array(8)]
    .map((_, i) => `
      ul li.ql-indent-${i + 1} {
        margin-inline-start: ${32 * (i + 1)}px;
        list-style-type: ${['disc', 'circle', 'square'][i % 3]};
        & + li.ql-indent-${i} {
        margin-block-end:8px;
        }
      }
      ol li.ql-indent-${i + 1} {
        margin-inline-start: ${32 * (i + 1)}px;
        list-style-type: ${['decimal', 'lower-alpha', 'lower-roman'][i % 3]};
      }
    `)
    .join('')}
    
  


`;
export const tableStyle = css `
  table {
    table-layout: auto;

    ${media.mobile `
      table-layout: fixed;
      width: 100%;
    `}

    margin-block: 16px;
    border-collapse: collapse;
    border: 1px solid ${({ theme }) => theme.colors.grey_3};
    max-width: 100%;
    width: fit-content;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.white_1};
    display: block;
    overflow-x: auto;
    box-shadow: ${({ theme }) => theme.appearance.box_shadow};
    margin-block: ${({ theme }) => theme.appearance.spacing * 3}px;
    box-shadow: ${({ theme }) => theme.appearance.box_shadow};
    &::-webkit-scrollbar {
      height: 8px;
    }
    caption {
      caption-side: top;
      padding: ${({ theme }) => theme.appearance.spacing}px;
      text-align: left;
      ${createFontSizeCSS('subtitle2')}
      font-weight: ${({ theme }) => theme.fontWeights.semibold};
      color: ${({ theme }) => theme.colors.grey_2};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.purple_1}EE;
      transition: background 400ms ease;
      border-radius: 99px;

      cursor: pointer;
    }

    thead th {
      position: sticky;
      top: 0;
      z-index: 2;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.purple_2};
    }
    th,
    td {
      vertical-align: top;
      text-align: left;
      min-width: 200px;
      padding-inline: ${({ theme }) => theme.appearance.spacing * 3}px;
      padding-block: ${({ theme }) => theme.appearance.spacing * 2}px;
    }
    th {
      background: ${({ theme }) => theme.colors.beige_1};
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey_3};
      border-right: 1px solid ${({ theme }) => theme.colors.grey_3};
      ${createFontSizeCSS('subtitle2')}
      white-space: nowrap;

      &:last-child {
        border-right: none;
      }
    }

    td {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
      border-right: 1px solid ${({ theme }) => theme.colors.grey_4};
      ${createFontSizeCSS('body2')}

      &:last-child {
        border-right: none;
      }
    }

    td:first-child,
    th:first-child {
      padding-left: ${({ theme }) => theme.appearance.spacing * 3}px;
    }
    td:last-child,
    th:last-child {
      padding-right: ${({ theme }) => theme.appearance.spacing * 3}px;
    }
    tr {
      &:nth-child(even) {
        background: ${({ theme }) => theme.colors.beige_3}AA;
      }
      &:hover {
        background-color: ${({ theme }) => theme.colors.beige_2};
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
`;
export const GlobalTypographyStylingHeadings = css `
  h1 {
    ${createFontSizeCSS('h2', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 7}px; // 56px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 3.5}px; // 28px
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h2 {
    ${createFontSizeCSS('h3', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 6}px; // 48px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 3}px; // 24px
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h3 {
    ${createFontSizeCSS('h4', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 5}px; // 40px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 2.5}px; // 20px
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h4 {
    ${createFontSizeCSS('h5', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 4}px; // 32px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 2}px; // 16px
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h5 {
    ${createFontSizeCSS('h6', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 3}px; // 24px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 1.5}px; // 12px
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h6 {
    ${createFontSizeCSS('subtitle1', true, 'bold')}
    margin-top: ${({ theme }) => theme.appearance.spacing * 2.5}px; // 20px
    margin-bottom: ${({ theme }) => theme.appearance.spacing * 1.5}px; // 12px
    &:where(hr + *) {
      margin-top: 0;
    }
  }
`;
export const GlobalTypographyStylingBody = css `
  p {
    ${createFontSizeCSS('body1')}
    &:not(:first-child) {
      margin-block-start: ${({ theme }) => theme.spacing.md}px;
    }
    &:not(:last-child) {
      margin-block-end: ${({ theme }) => theme.spacing.md}px;
    }
  }

  ul,
  ol {
    ${createFontSizeCSS('body1')}

    padding-inline-start: ${({ theme }) => theme.appearance.spacing * 3}px; // 24px

    &:not(:first-child) {
      margin-block-start: ${({ theme }) => theme.spacing.md}px;
    }
    &:not(:last-child) {
      margin-block-end: ${({ theme }) => theme.spacing.md}px;
    }
    ul,
    ol {
      display: block;
      margin-block-start: 0;
      margin-block-end: ${({ theme }) => theme.appearance.spacing * 1}px;
    }
    li {
      margin-block: ${({ theme }) => theme.appearance.spacing * 0.75}px; // 6px
      padding-left: ${({ theme }) => theme.appearance.spacing * 0.75}px; // 6px
    }
  }
  hr {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
    width: 100%;
    margin-block-start: ${({ theme }) => theme.spacing.lg}px;
    margin-block-end: ${({ theme }) => theme.spacing.lg}px;
  }
  strong {
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }
  blockquote {
    ${createFontSizeCSS('body1')}
    margin-block: ${({ theme }) => theme.appearance.spacing * 2}px;
    padding-inline-start: ${({ theme }) => theme.appearance.spacing * 3}px;
    border-width: 0;
    position: relative;
    padding-block: ${({ theme }) => theme.appearance.spacing * 1}px;
    &:after {
      background-color: ${({ theme }) => theme.colors.purple_1};
      border-radius: 2px;
      bottom: ${({ theme }) => theme.appearance.spacing}px;
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;

      height: 100%;
    }
  }
  pre {
    ${createFontSizeCSS('body2')}
    padding: ${({ theme }) => theme.appearance.spacing * 4}px;
    border: 1px solid ${({ theme }) => theme.colors.grey_4};
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.beige_4};
  }

  a {
    color: ${({ theme }) => theme.colors.purple_2};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.purple_1};
    }

    &:active,
    &:focus,
    &:visited {
      color: ${({ theme }) => theme.colors.purple_3};
    }
  }
  ${tableStyle}
`;
export const GlobalTypographyStylingV2 = css `
  ${GlobalTypographyStylingHeadings}
  ${GlobalTypographyStylingBody}
`;
